import React, {useCallback, useState} from 'react';
import {useSelector} from "react-redux";

import {formatDistance, formatSpeed, formatDate, formatCoordinate, formatPosition} from '../common/formatter';
import ReportFilter from './ReportFilter';
import ReportLayoutPage from './ReportLayoutPage';
import { useAttributePreference, usePreference } from '../common/preferences';
import { t } from '../common/LocalizationProvider';
import AddressCell from "../details/AddressCell";

import {Checkbox, FormControlLabel, Grid, Paper, makeStyles} from '@material-ui/core';
import {DataGrid, GridOverlay} from '@material-ui/data-grid';
import { useTheme } from "@material-ui/core/styles";
import {cyberStyles} from "../cssShared/cyberTheme";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
}));

const Filter = ({ setItems, loading, setLoading }) => {
  const classes = useStyles();

  const [openSnackbar, setOpenSnackbar] = useState(null)
  const [wrongPositions, setWrongPositions] = useState(false);
  const administrator = useSelector(state => state.session.user && state.session.user.administrator)

  const handleSubmit = useCallback(async (deviceIds, from, to, mail, headers) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let query = new URLSearchParams({ from, to, mail });
    deviceIds.forEach(deviceId => query.append("deviceId", deviceId))
    if (headers.Accept !== 'application/json')
      query.append("timeZone", timeZone)

    const apiMethod = wrongPositions ? 'wrongPositions' : 'route';
    const response = await fetch(`/api/reports/${apiMethod}?${query.toString()}`, { headers });
    if (response.ok) {
      if (mail)
        setOpenSnackbar('EmailReportAlert')
      const contentType = response.headers.get('content-type');
      if (contentType) {
        if (contentType === 'application/json') {
          const res = await response.json()
          setItems(res);
          if (res.length === 0)
            setOpenSnackbar('replayNoData')
        } else {
          window.location.assign(window.URL.createObjectURL(await response.blob()));
          setOpenSnackbar('ExcelFileExported')
        }
      }
    } else
      setOpenSnackbar('UnknownProblem')
    setLoading(null)

  },[setItems, wrongPositions])

  return (
      <ReportFilter handleSubmit={handleSubmit} openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} loading={loading} setLoading={setLoading}>
        {administrator && <Grid item xs={12} sm={6}>
          <FormControlLabel
              className={classes.checkboxLabel}
              control={<Checkbox checked={wrongPositions} onChange={e => setWrongPositions(e.target.checked)}/>}
              label={t('ShowWrongPositions')}/>
        </Grid>}
      </ReportFilter>
  );
};

const RouteReportPage = () => {
  const classes = useStyles();
  const distanceUnit = useAttributePreference('distanceUnit');
  const speedUnit = useAttributePreference('speedUnit');
  const coordinateFormat = usePreference('coordinateFormat');
  const theme = useTheme();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(null);

  const columns = [
    {
      headerName: t('reportDeviceName'),
      field: 'deviceName',
      type: 'string',
      width: 220,
      // valueFormatter: ({ value }) => formatPosition(value),
      renderCell: (params) => {
        return (
            <Tooltip title={formatPosition(params.value)} placement="top-start" arrow>
              <div>
                {formatPosition(params.value)}
              </div>
            </Tooltip>
        );
      },
    }, {
      headerName: t('positionFixTime'),
      field: 'fixTime',
      type: 'dateTime',
      width: theme.dimensions.columnWidthDate,
      valueFormatter: ({ value }) => formatDate(value),
    }, {
      headerName: t('positionLatitude'),
      field: 'latitude',
      type: 'number',
      width: theme.dimensions.columnWidthNumber,
      valueFormatter: ({ value }) => formatCoordinate('latitude', value, coordinateFormat),
    }, {
      headerName: t('positionLongitude'),
      field: 'longitude',
      type: 'number',
      width: theme.dimensions.columnWidthNumber,
      valueFormatter: ({ value }) => formatCoordinate('longitude', value, coordinateFormat),
    }, {
      headerName: t('positionSpeed'),
      field: 'speed',
      type: 'number',
      width: theme.dimensions.columnWidthString,
      valueFormatter: ({ value }) => formatSpeed(value, speedUnit),
    }, {
      headerName: t('positionAddress'),
      field: 'address',
      type: 'string',
      width: theme.dimensions.columnWidthString,
      renderCell: (params) => <AddressCell latitude={params.row?.latitude} longitude={ params.row?.longitude}/>,
    }, {
      headerName: t('positionIgnition'),
      field: 'ignition',
      type: 'boolean',
      width: theme.dimensions.columnWidthBoolean,
      valueGetter: ({ row }) => row.attributes.ignition,
      valueFormatter: ({ value }) =>"No",
    }, {
      headerName: t('positionTotalDistance'),
      field: 'totalDistance',
      hide: true,
      type: 'number',
      width: theme.dimensions.columnWidthNumber,
      valueGetter: ({ row }) => row.attributes.totalDistance,
      valueFormatter: ({ value }) => formatDistance(value, distanceUnit),
    }]


  return (
      <ReportLayoutPage filter={<Filter setItems={setItems} loading={loading} setLoading={setLoading} />}>
        <Paper className={classes.paper}>
          <DataGrid
              loading={loading}
              rows={items}
              columns={columns}
              // hideFooterPagination
              autoHeight
              components={{
                  LoadingOverlay: () => (
                      <GridOverlay>
                          <CircularProgress className={classes.color} />
                      </GridOverlay>
                  )
              }}
              componentsProps={{
                pagination: {
                  classes: {
                    caption: classes.yourCustomCaptionClass
                  }
                }
              }}
          />
        </Paper>
      </ReportLayoutPage>
  );
};

export default RouteReportPage;